module.exports = __webpack_public_path__ + "48f5204a2902b7e414fab24264dc5a09.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/space-draw.png
 ** module id = 543
 ** module chunks = 1
 **/